class StockStatus extends HTMLElement {
  connectedCallback() {
    this.variants = JSON.parse(this.dataset.variants || '[]');
    this.initialStatus = this.dataset.initialStatus || 'regular';

    // Initial gewählte Variante prüfen
    const selectedInput = document.querySelector('[name="id"]:checked, [name="id"]');
    if (selectedInput) {
      const variant = this.variants.find(v => v.id == selectedInput.value);
      if (variant) {
        this.updateFromVariant(variant);
      } else {
        this.update(this.initialStatus);
      }
    } else {
      this.update(this.initialStatus);
    }

    document.addEventListener('change', (e) => {
      if (e.target.matches('[name="id"]')) {
        const variant = this.variants.find(v => v.id == e.target.value);
        if (variant) this.updateFromVariant(variant);
      }
    });

    document.addEventListener('variant:change', (e) => {
      this.updateFromVariant(e.detail.variant);
    });
  }

  updateFromVariant(variant) {
    const status = variant.available ? this.initialStatus : 'out-of-stock';
    this.update(status);
  }

  update(status) {
    this.setAttribute('data-status', status);
    this.querySelectorAll('[data-slot]').forEach(el => {
      el.hidden = el.dataset.slot !== status;
    });
  }
}

customElements.define('stock-status', StockStatus);